import BaseReportStore from './base-store'

import publisherStore from 'modules/offer/stores/publisher'
import siteStore from 'modules/admin/stores/site'
import pageStore from 'modules/path/stores/page'
import pathStore from 'modules/path/stores/path'
import allocationStore from 'modules/offer/stores/allocation'
import customFieldStore from 'modules/path/stores/field'
import pathUserProfileStore from 'modules/path/stores/user_profile'
import metaFieldStore from 'modules/settings/stores/meta-field'

export default new class SurveysStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'surveys'

  publisher = this.attachEntity(publisherStore)
  path = this.attachEntity(pathStore)
  page = this.attachEntity(pageStore)
  allocation = this.attachEntity(allocationStore, { labelKey: 'description' })
  customField = this.attachEntity(customFieldStore, {
    extra: ['id'],
    filterValue: 'value',
    valueKey: "key",
    labelFn: ({ value, label, id }) => `[#${id}] - (${value}) ${label}`
  })
  pathUserProfile = this.attachEntity(pathUserProfileStore)
  metaField = this.attachEntity(metaFieldStore, {
    labelKey: 'key',
    valueKey: 'key',
    labelFn: ({ value }) => value,
  });

  removeNotAnsered(children) {
    return children.some(({ key, value, children }, idx, arr) => {
      if (key === 'answer' && value === '') {
        arr.splice(idx, 1)
        return true
      }
      if (children) {
        this.removeNotAnsered(children)
      }
      return false
    })
  }

  async fetchData(...args) {
    await super.fetchData(...args)
    this.removeNotAnsered(this.collection.data.children)
  }
}
